module.exports = __webpack_public_path__ + "static/media/muddler.c1ac17f0.png";